const candidateProgressConstants = {
    PENDING_READINESS_CHECK: 'pending_readiness_check',
    READINESS_CHECK_IN_PROGRESS: 'readiness_check_in_progress',
    READY: 'ready',
    IN_PROGRESS: 'in_progress_heartbeat',
    ASSETS_LOAD_PROGRESS: 'assets_load_progress',
    ASSETS_DOWNLOAD_INFO: 'assets_download_info',
};

export default candidateProgressConstants;
